export default class ContactForm {

  constructor() {
    this.bindEvents();
    this.handleInitialState();
  }

  bindEvents() {
    $("#call-subject-select").off("change").on("change", function() {
      if ($(this).val() == "instructor_need_supplies") {
        $("#supplies-choice").show();
        $("#emergency-level-choice").hide();
        $("#emergency-level-select").prop("disabled", true);
      } else {
        $("#supplies-choice").hide();
        $("#emergency-level-choice").show();
        $("#emergency-level-select").prop("disabled", false);
        $(".supply-choice").prop("checked", false);
      }
    });

    $("#contact").off("submit").on("submit", function(e) {
      const subject = $("#call-subject-select").val();
      if (subject === "instructor_need_supplies") {
        const checkedSupplies = $(".supply-choice:checked").length;
        if (checkedSupplies === 0) {
          e.preventDefault();
          $("#supplies-error").text(I18n.t('monitors.contact_team.index.supply_required')).show();
          return false;
        }
      }
      $("#supplies-error").hide();
    });

    $(".supply-choice").off("change").on("change", function() {
      if ($(".supply-choice:checked").length > 0) {
        $("#supplies-error").hide();
      }
    });
  }

  handleInitialState() {
    const selectedValue = $("#call-subject-select").val();
    if (selectedValue == "instructor_need_supplies") {
      $("#supplies-choice").show();
      $("#emergency-level-choice").hide();
      $("#emergency-level-select").prop("disabled", true);
    } else {
      $("#supplies-choice").hide();
      $("#emergency-level-choice").show();
      $("#emergency-level-select").prop("disabled", false);
      $(".supply-choice").prop("checked", false);
    }
  }

  onDataChanged(data) {
      this.planning.onDataChanged(data);
  }

  onDestroy() {
  }
}